import * as React from 'react';
import { graphql, useStaticQuery, navigate } from 'gatsby';

import { styled } from '../themeContext';
import { ReactComponent as DownIconSvg } from './gameLanguageSelector/down.svg';

type GameLanguageSelectorProps = {
  className?: string,
  currentLocale: string,
};

const LANGUAGES = {
  ko: '한국어',
  en: 'English',
  ja: '日本語',
  'zh-Hant': '繁體中文',
  'zh-Hans': '简体中文',
  th: 'ภาษาไทย',
  de: 'Deutsch',
  fr: 'Français',
} as const;

const Container = styled('div')({
  display: 'inline-flex',
  alignItems: 'center',
});

const Select = styled('select')({
  textAlignLast: 'center',
  fontSize: 'inherit',
  color: 'inherit',
  background: 'inherit',
  border: 'none',
  outline: 'none',
  appearance: 'none',
});

const DownIcon = styled(DownIconSvg)({
  marginLeft: '0.5em',
  fontSize: '0.5em',
});

const GameLanguageSelector: React.FC<GameLanguageSelectorProps> = ({
  className,
  currentLocale,
}) => {
  const data = useStaticQuery<GatsbyTypes.GameLanguageSelectorQuery>(graphql`
    query GameLanguageSelector {
      allEventTarget {
        nodes {
          language
        }
      }
    }
  `);
  type Language = 'ko' | 'en' | 'ja' | 'zh-Hant' | 'th' | 'fr' | 'de';
  type Locale = { language: Language };
  const locales = data.allEventTarget.nodes as Array<Locale>;
  const handleChange: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
    const locale = e.currentTarget.value;
    navigate(`/${locale}/`, { replace: true });
  };
  return (
    <Container className={className}>
      <Select
        defaultValue={currentLocale}
        onChange={handleChange}
      >
        {locales.map(locale => (
          <option
            key={locale.language}
            value={locale.language}
          >
            {LANGUAGES[locale.language]}
          </option>
        ))}
      </Select>
      <DownIcon />
    </Container>
  );
};

export default GameLanguageSelector;
